import { Typography } from "@material-ui/core"

export const PIDTestView = ({ procedureData }: { procedureData: any }) => {
  return (
    <div>
      <Typography variant="body1">
        Test duration :{procedureData?.pid_test?.test_duration ?`${procedureData.pid_test.test_duration} hours`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test temperature :{procedureData?.pid_test?.test_temperature ?`${procedureData.pid_test.test_temperature} °C`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Test humidity :{procedureData?.pid_test?.test_humidity ?`${procedureData.pid_test.test_humidity} %RH`  : "N/A"} 
      </Typography>
      <Typography variant="body1">
        Equipment Calibration Date :{procedureData?.pid_test?.equipment_calibration_date ? procedureData.pid_test.equipment_calibration_date.substring(0, 10) : "N/A"}
      </Typography>
      <Typography variant="body1">
        Current voltage normal : {procedureData?.pid_test?.voltage_normal ? procedureData.pid_test.voltage_normal : "N/A"}
      </Typography>

    </div>
  )
}